import axios from "axios";
export default axios.create({
  baseURL: "https://api.cobmindex.com/api/v1/",
});